import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ru from '@/locales/ru';
import en from '@/locales/en';
import kk from '@/locales/kk';
import country from '@/store/country';
import pluralization from '@/helpers/pluralization';

Vue.use(VueI18n);

let locale = localStorage.getItem('locale');

if (!locale || !['en', 'ru'].includes(locale)) {
    locale = country.state().country === 'AE' ? 'en' : 'ru';
    localStorage.setItem('locale', locale);
}

export const i18n = new VueI18n({
    locale,
    messages: { ru, en, kk },
    pluralizationRules: {
        ru: pluralization,
    },
});